import Helper from '../helpers/Helper';

export default class Imprint {
    constructor() {
        this.el = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.buildHtml();
    }
    buildHtml() {
        let dom = this.el.querySelector('.legal-text'),
            company = JSON.parse(decodeURIComponent(dom.getAttribute('data-company'))),
            copyrights = decodeURIComponent(dom.getAttribute('data-copyrights')),

            // ==============================================================
            // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
            //
            // also update tecpage-files/_coming_soon.php
            // when changing the imprint
            //
            // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
            // ==============================================================
            html =
                `
            <div class="imprint__inner-row module__inner-row">

            <div class="imprint__legal-text-col module__inner-col module__cms">
                <h2 class="imprint__inner-title module__title font-h2 color-h2">Angaben gemäß §&nbsp;5&nbsp;DDG</h2>
                <p>${company.firma1}<br />
                ` +
                (company.firmierung !== undefined &&
                company.firmierung !== null &&
                company.firmierung !== ''
                    ? `${company.firmierung}<br />`
                    : ``) +
                `
                ${company.strasse}<br />
                ${company.plz} ${company.ort}<br />
                ${company.land}</p>
                <p><strong>Vertreten durch:</strong><br />
                ${
                    company.contact_person.first_name !== undefined &&
                    company.contact_person.first_name !== null &&
                    company.contact_person.first_name !== '' &&
                    company.contact_person.last_name !== undefined &&
                    company.contact_person.last_name !== null &&
                    company.contact_person.last_name !== ''
                        ? company.contact_person.first_name +
                          ' ' +
                          company.contact_person.last_name +
                          '<br />'
                        : ''
                }
                ${
                    company.contact_person_2.first_name !== undefined &&
                    company.contact_person_2.first_name !== null &&
                    company.contact_person_2.first_name !== '' &&
                    company.contact_person_2.last_name !== undefined &&
                    company.contact_person_2.last_name !== null &&
                    company.contact_person_2.last_name !== ''
                        ? company.contact_person_2.first_name +
                          ' ' +
                          company.contact_person_2.last_name +
                          '<br />'
                        : ''
                }
                ${
                    company.contact_person_3.first_name !== undefined &&
                    company.contact_person_3.first_name !== null &&
                    company.contact_person_3.first_name !== '' &&
                    company.contact_person_3.last_name !== undefined &&
                    company.contact_person_3.last_name !== null &&
                    company.contact_person_3.last_name !== ''
                        ? company.contact_person_3.first_name +
                          ' ' +
                          company.contact_person_3.last_name +
                          '<br />'
                        : ''
                }
                </p>


                ${(() => {
                    // "Verantwortlich für den Inhalt"
                    const rc = company.responsible_for_content;
                    if (!rc) return '';
                    // join present parts only, skips empty name/address
                    const name = [rc.first_name, rc.last_name].filter(Boolean).join(' ');
                    const parts = [name, rc.address].filter(Boolean);
                    if (!parts.length) return '';
                    return `<h2 class="imprint__inner-title module__title font-h2 color-h2">Verantwortlich für den Inhalt gemäß § 18 Abs. 2 MStV:</h2>
                    <p>${parts.join(', ')}</p>`;
                })()}

                ${(() => {

                    // "Berufsbezeichnung und berufsrechtliche Regelungen"
                    const rp = company.regulated_profession;
                    const rp2 = company.regulated_profession_2;
                    const rp3 = company.regulated_profession_3;
                    if (!rp || company.regulated_profession_applicable !== '1') return '';

                    // flatten suffixed keys into entries
                    const entries = [
                        { job: rp.job_name,         chamber: rp.chamber_name,         link: rp.chamber_link },
                        { job: rp2 && rp2.job_name, chamber: rp2 && rp2.chamber_name, link: rp2 && rp2.chamber_link },
                        { job: rp3 && rp3.job_name, chamber: rp3 && rp3.chamber_name, link: rp3 && rp3.chamber_link },
                    ];

                    const jobs     = entries.map(e => e.job).filter(Boolean);
                    const chambers = entries.filter(e => e.chamber || e.link);

                    if (!jobs.length && !chambers.length) return '';

                    const jobLines = jobs
                        .map(job => `<p>Die gesetzliche Berufsbezeichnung ${job} wurde in der Bundesrepublik Deutschland verliehen.</p>`)
                        .join('');

                    const chamberLines = chambers
                        .map(e => `<p>Handwerkskammer ${e.chamber || ''}${e.link ? `<br><a href="${e.link}" target="_blank" rel="noopener noreferrer">${e.link}</a>` : ''}</p>`)
                        .join('');

                    const hwoLines = jobs
                        .map(job => `<p>Für ${job} gilt die Handwerksordnung, die unter <a href="https://www.gesetze-im-internet.de/hwo/" target="_blank" rel="noopener noreferrer">https://www.gesetze-im-internet.de/hwo/</a> eingesehen werden kann.</p>`)
                        .join('');

                    return `<h2 class="imprint__inner-title module__title font-h2 color-h2">Berufsbezeichnung und berufsrechtliche Regelungen:</h2>
                    ${jobLines}
                    ${chambers.length ? `<p><strong>Zuständige Handwerkskammer:</strong></p>${chamberLines}` : ''}
                    ${hwoLines}`;

                })()}

                <h2 class="imprint__inner-title module__title font-h2 color-h2">Streitschlichtung</h2>
                <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
            </div>

            <div class="imprint__legal-text-col module__inner-col module__cms">
                <h2 class="imprint__inner-title module__title font-h2 color-h2">Kontakt</h2>
                <p>Telefon: <a href="tel:${company.telefon}" class="module__link--underlined">${
                    company.telefon
                }</a><br />
                ${
                    company.fax !== undefined && company.fax !== null && company.fax !== ''
                        ? 'Telefax: ' + company.fax + '<br />'
                        : ''
                }
                E-Mail: <a href="mailto:${company.email}" class="module__link--underlined">${
                    company.email
                }</a></p>
                ${
                    company.registergericht && company.handelsregisternummer
                        ? `<h2 class="imprint__inner-title module__title font-h2 color-h2">Registereintrag</h2>
                <p>Eintragung im Handelsregister<br/>
                Registergericht: ${company.registergericht}<br/>
                Registernummer: ${company.handelsregisternummer}</p>`
                        : ``
                }
                ${
                    company.ustid !== undefined && company.ustid !== null && company.ustid !== ''
                        ? `<h2 class="imprint__inner-title module__title font-h2 color-h2">Umsatzsteuer</h2>
                <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br/>
                ${company.ustid}</p>`
                        : ``
                }
                </div>
            </div>
        `;
        if (copyrights && copyrights !== '') {
            html +=
                '<div class="imprint__inner-row module__inner-row"><div class="imprint__legal-text-col imprint__legal-text-license module__cms module__inner-col">';
            html +=
                '<h3 class="imprint__inner-subtitle module__subtitle font-h3 color-h3">Bildlizenzierung</h3>';
            if (copyrights === '%REPLACE_COPYRIGHTS%') {
                html += 'Wird automatisch beim Veröffentlichen gesetzt.';
            } else {
                if (!Helper.isInsideEditor()) {
                    copyrights = copyrights.replace(
                        '</ul>',
                        '<li>© Tryfonov / #318903457 - Adobe Stock</li></ul>'
                    );
                }
                html += copyrights;
            }
            html += '</div></div>';
        }

        // ==============================================================
        // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
        //
        // also update tecpage-files/_coming_soon.php
        // when changing the imprint
        //
        // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
        // ==============================================================

        html += `
            <div class="imprint__inner-row module__inner-row">
            <div class="imprint__legal-text-col module__cms module__inner-col">
            <h2 class="imprint__inner-title module__title font-h2 color-h2">Website Service</h2>
            <p>Diese Seite wurde von ${company.firma1} mit dem <nobr>TECWORLD Homepage-Baukasten</nobr> erstellt, powered by
            <a href="https://www.deha.de" target="_blank" class="">DEHA Elektrohandelsgesellschaft mbH & Co.KG</a>
            </p>
            </div>
            </div>`;

        dom.innerHTML = html;
    }
}
